(function () {
  'use strict';

  var R36S_ID = 9374899175643;
  var CARRY_CASE_ID = 9374900453595;
  var CARRY_CASE_VARIANT = 48879899148507;
  var EARBUDS_ID = 9375002919131;
  var EARBUDS_VARIANT = 48883810402523;
  var GRIP_ID = 9375691276507;
  var GRIP_VARIANT = 48883722027227;
  var FREE_SHIPPING_CENTS = 10000;

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function renderShippingBar(cart) {
    var total = cart.total_price;
    var el = document.createElement('div');
    el.className = 'retro-shipping-bar';
    if (total >= FREE_SHIPPING_CENTS) {
      el.innerHTML = '<p class="retro-shipping-bar__msg retro-shipping-bar__msg--done">&#10003; Free shipping unlocked!</p>';
    } else {
      var remaining = ((FREE_SHIPPING_CENTS - total) / 100).toFixed(2);
      var pct = Math.round((total / FREE_SHIPPING_CENTS) * 100);
      el.innerHTML = '<p class="retro-shipping-bar__msg">Add <strong>$' + remaining + '</strong> more for free shipping</p><div class="retro-shipping-bar__track"><div class="retro-shipping-bar__fill" style="width:' + pct + '%"></div></div>';
    }
    return el;
  }

  function renderUpsell(cart) {
    var ids = cart.items.map(function (i) { return i.product_id; });
    var hasR36S = ids.includes(R36S_ID);
    var hasCase = ids.includes(CARRY_CASE_ID);
    var hasEarbuds = ids.includes(EARBUDS_ID);
    var hasGrip = ids.includes(GRIP_ID);
    var rows = [];
    var hasBundleTrigger = hasEarbuds || hasGrip;

    if (hasR36S && !hasCase) {
      var nameHtml = hasBundleTrigger
        ? 'Carry Case <span class="retro-upsell-bundle-tag">20% off</span>'
        : 'Carry Case';
      var priceHtml = hasBundleTrigger
        ? '<span class="retro-upsell-row__price retro-upsell-row__price--sale">~$20.00</span><span class="retro-upsell-row__price retro-upsell-row__price--was">$25.00</span>'
        : '<span class="retro-upsell-row__price">$25.00</span>';
      rows.push('<div class="retro-upsell-row"><div class="retro-upsell-row__info"><span class="retro-upsell-row__name">' + nameHtml + '</span>' + priceHtml + '</div><button class="retro-upsell-row__btn" data-variant="' + CARRY_CASE_VARIANT + '">+ Add</button></div>');
    }

    if (hasR36S && !hasEarbuds) {
      rows.push('<div class="retro-upsell-row"><div class="retro-upsell-row__info"><span class="retro-upsell-row__name">Gaming Earbuds <span class="retro-upsell-bundle-tag">case 20% off</span></span><span class="retro-upsell-row__price">$35.00</span></div><button class="retro-upsell-row__btn" data-variant="' + EARBUDS_VARIANT + '">+ Add</button></div>');
    }

    if (hasR36S && !hasGrip) {
      rows.push('<div class="retro-upsell-row"><div class="retro-upsell-row__info"><span class="retro-upsell-row__name">R36S Grip <span class="retro-upsell-bundle-tag">case 20% off</span></span><span class="retro-upsell-row__price">$20.00</span></div><button class="retro-upsell-row__btn" data-variant="' + GRIP_VARIANT + '">+ Add</button></div>');
    }

    if (!hasR36S && hasBundleTrigger && !hasCase) {
      rows.push('<div class="retro-upsell-row"><div class="retro-upsell-row__info"><span class="retro-upsell-row__name">Carry Case <span class="retro-upsell-bundle-tag">20% off</span></span><span class="retro-upsell-row__price retro-upsell-row__price--sale">~$20.00</span><span class="retro-upsell-row__price retro-upsell-row__price--was">$25.00</span></div><button class="retro-upsell-row__btn" data-variant="' + CARRY_CASE_VARIANT + '">+ Add</button></div>');
    }

    if (!rows.length) return null;
    var el = document.createElement('div');
    el.className = 'retro-cart-upsell';
    el.innerHTML = '<p class="retro-cart-upsell__title">Complete your setup</p><div class="retro-cart-upsell__items">' + rows.join('') + '</div>';
    if (hasBundleTrigger && !hasCase) {
      el.innerHTML += '<p class="retro-upsell-bundle-note">Bundle discount applied automatically at checkout</p>';
    }
    return el;
  }

  function wireUpsellButtons(upsell) {
    if (!upsell) return;
    upsell.querySelectorAll('.retro-upsell-row__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.textContent = 'Adding...';
        btn.disabled = true;
        addVariant(Number(btn.dataset.variant)).then(function () {
          setTimeout(refreshCartUI, 400);
        }).catch(function () {
          btn.textContent = 'Error';
        });
      });
    });
  }

  function refreshCartUI() {
    getCart().then(function (cart) {
      if (!cart || !cart.item_count) return;
      var content = document.querySelector('.cart-drawer__content');
      if (!content) return;
      content.querySelectorAll('.retro-shipping-bar, .retro-cart-upsell').forEach(function (el) { el.remove(); });
      var itemsEl = content.querySelector('.cart-drawer__items');
      var summaryEl = content.querySelector('.cart-drawer__summary');
      var bar = renderShippingBar(cart);
      var upsell = renderUpsell(cart);
      if (itemsEl) itemsEl.insertAdjacentElement('beforebegin', bar);
      if (summaryEl && upsell) { summaryEl.insertAdjacentElement('beforebegin', upsell); wireUpsellButtons(upsell); }
    });
  }

  function injectTrustBadges() {
    if (document.querySelector('.retro-trust-badges')) return;
    var btn = document.querySelector('.product-form__submit, product-form button[type="submit"], [name="add"]');
    if (!btn) return;
    var anchor = btn.closest('form, product-form') || btn.parentElement;
    if (!anchor) return;
    var badges = document.createElement('div');
    badges.className = 'retro-trust-badges';
    badges.innerHTML = '<div class="retro-trust-badge"><span class="rtb-icon">SHIP</span>Worldwide Shipping</div><div class="retro-trust-badge"><span class="rtb-icon">30D</span>Free Returns</div><div class="retro-trust-badge"><span class="rtb-icon">$100</span>Free Shipping</div><div class="retro-trust-badge"><span class="rtb-icon">SSL</span>Secure Checkout</div>';
    anchor.insertAdjacentElement('afterend', badges);
  }

  var stickyCartEl = null;
  var stickyObserver = null;

  function initStickyCart() {
    if (stickyCartEl || !window.location.pathname.includes('/products/')) return;
    var mainBtn = document.querySelector('.product-form__submit, product-form button[type="submit"], [name="add"]');
    if (!mainBtn) return;
    var titleEl = document.querySelector('h1');
    var titleText = titleEl ? titleEl.textContent.trim().split('|')[0].trim() : 'Add to Cart';
    if (titleText.length > 38) titleText = titleText.substring(0, 38) + '\u2026';
    stickyCartEl = document.createElement('div');
    stickyCartEl.className = 'retro-sticky-cart';
    stickyCartEl.setAttribute('aria-hidden', 'true');
    stickyCartEl.innerHTML = '<div class="retro-sticky-cart__inner"><span class="retro-sticky-cart__title">' + titleText + '</span><button class="retro-sticky-cart__btn" type="button">Add to Cart</button></div>';
    document.body.appendChild(stickyCartEl);
    stickyCartEl.querySelector('.retro-sticky-cart__btn').addEventListener('click', function () {
      mainBtn.click();
      stickyCartEl.classList.remove('retro-sticky-cart--visible');
    });
    if ('IntersectionObserver' in window) {
      stickyObserver = new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting;
        stickyCartEl.classList.toggle('retro-sticky-cart--visible', visible);
        stickyCartEl.setAttribute('aria-hidden', String(!visible));
      }, { threshold: 0.1 });
      stickyObserver.observe(mainBtn);
    }
  }

  var cartObserver = null;
  function watchCart() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || cartObserver) return;
    cartObserver = new MutationObserver(function () {
      if (document.querySelector('.cart-drawer__content')) setTimeout(refreshCartUI, 80);
    });
    cartObserver.observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    injectTrustBadges();
    initStickyCart();
    watchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('page:loaded', function () {
    stickyCartEl = null;
    if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
    injectTrustBadges();
    initStickyCart();
  });
})();
